import { Injectable } from '@angular/core'
import { IEmployerDetailsVM } from '@candidate/app/models/employer/employer.model'
import { environment } from '@candidate/environments/environment'
import { RestApiClient } from '@engineering11/web-api-rest'
import { Observable, throwError } from 'rxjs'
import { catchError, map } from 'rxjs/operators'
import { DEFAULT_NETWORK_MONITORING_CONFIG, getBaseSuffix } from 'shared-lib'

@Injectable({
  providedIn: 'root',
})
export class PublicEmployerService {
  private restApiClient: RestApiClient
  constructor() {
    this.restApiClient = new RestApiClient({
      baseUrl: environment.services.employer,
      token: '',
      baseSuffix: getBaseSuffix(environment, 'employer'),
      ...DEFAULT_NETWORK_MONITORING_CONFIG,
    })
  }

  get(customerKey: string): Observable<IEmployerDetailsVM> {
    return this.restApiClient.get<IEmployerDetailsVM>(`/employer/${customerKey}`).pipe(
      map(item => item.data),
      catchError(err => throwError(err))
    )
  }
}
